import request from '@/utils/request'

// 加载表格数据
export function getShopList(params){
    return request({
        url: '/server/shop/select',
        method: 'get',
        params: params
    })
}
// 加载表格数据
export function getLazada(params){
    return request({
        url: '/server/shop/select',
        method: 'get',
        params: params
    })
}

// 加载表格数据
export function getLazadaCategory(shopId){
    return request({
        url: '/server/shop/getLazadaCategory/' + shopId,
        method: 'get',
    })
}

// 加载表格数据
export function syncLazada(data){
    return request({
        url: '/server/universal/template/syncLazada',
        method: 'post',
        data: data
    })
}


// 加载表格数据
export function getChannelList(data){
    return request({
        url: '/server/order/channelList',
        method: 'GET',
        params: data
    })
}


// 加载表格数据
export function syncShopee(data){
    return request({
        url: '/server/universal/template/syncShopee',
        method: 'post',
        data: data
    })
}


// 加载表格数据
export function syncTiktok(data){
    return request({
        url: '/server/universal/template/syncTiktok',
        method: 'post',
        data: data
    })
}


// 加载表格数据
export function getCategoryAttribute(data){
    return request({
        url: '/server/lazada/product/getCategoryAttribute',
        method: 'get',
        params: data
    })
}



// 加载表格数据
export function getBrandByPages(data){
    return request({
        url: '/server/lazada/product/getBrandByPages',
        method: 'get',
        params: data
    })
}



export function templateTiming(data) {
    return request({
      url: "/server/universal/template/timing",
      method: "post",
      data: data
    })
  }